module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "create-user"
  }, [(_vm.loading) ? _c('loader', {
    attrs: {
      "loading": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "create-user-title d-flex align-items-center"
  }, [_c('i', {
    staticClass: "fa fa-plus fa-sm"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("createUser.title")))])]), _vm._v(" "), _c('div', {
    staticClass: "create-user-search container"
  }, [_c('div', {
    staticClass: "msg-search"
  }, [_vm._v(_vm._s(_vm.$t("createUser.msgSearch")))]), _vm._v(" "), _c('form', {
    staticClass: "form-search",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.searchUser($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-search row"
  }, [_c('div', {
    staticClass: "col d-flex align-items-center justify-content-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.obj.email),
      expression: "obj.email",
      modifiers: {
        "trim": true
      }
    }],
    class: !_vm.validEmail(_vm.obj.email) && _vm.obj.emailBlured ? 'is-invalid' : '',
    attrs: {
      "id": "search",
      "type": "text"
    },
    domProps: {
      "value": (_vm.obj.email)
    },
    on: {
      "blur": [function($event) {
        _vm.obj.emailBlured = true;
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.obj.email = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "background-color": _vm.currentBrand.linksColor
    },
    on: {
      "click": _vm.searchUser
    }
  }, [_vm._v(_vm._s(_vm.$t("createUser.searchIt")))])], 1)])]), _vm._v(" "), (_vm.obj.submitted) ? _c('div', [_c('div', {
    staticClass: "msg-create"
  }, [(!_vm.newUser) ? [(_vm.isHasAccessBrand) ? [_c('p', [_vm._v(_vm._s(_vm.$t("createUser.hasAccessBrand", {
    brand: _vm.currentBrand.name.toUpperCase()
  })))])] : [_c('p', [_vm._v(_vm._s(_vm.$t("createUser.updateBrand")))]), _vm._v(" "), _vm._l((_vm.dataUser.userBrand), function(ub) {
    return _c('p', [_c('i', [_vm._v(_vm._s(ub.brand.name.toUpperCase()))])])
  }), _vm._v(" "), _c('p', {
    staticClass: "mt-5"
  }, [_vm._v(_vm._s(_vm.$t("createUser.confimUpdateBrand", {
    brand: _vm.currentBrand.name.toUpperCase()
  })))])]] : _vm._e()], 2), _vm._v(" "), (_vm.newUser) ? _c('form', {
    staticClass: "form-create"
  }, [_c('div', {
    staticClass: "container-create"
  }, [_c('div', {
    staticClass: "msg-error-input"
  }, [_vm._v(_vm._s(_vm.msgInput ? _vm.$t("createUser.fieldsError") : _vm.msgInput))]), _vm._v(" "), _vm._l((_vm.types), function(type) {
    return _c('div', {
      key: type.name,
      class: 'adduser-input m-' + type.name
    }, [_c('label', {
      attrs: {
        "label-class": "label-form",
        "label-for": type.name
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(type.label)) + " "), (type.required) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (_vm.form[type.name]),
        expression: "form[type.name]",
        modifiers: {
          "trim": true
        }
      }, {
        name: "validate",
        rawName: "v-validate",
        value: (type.required),
        expression: "type.required"
      }],
      attrs: {
        "id": type.name,
        "type": "text",
        "placeholder": "",
        "disabled": _vm.isDisabled || type.disabled
      },
      domProps: {
        "value": (_vm.form[type.name])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, type.name, $event.target.value.trim())
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])
  }), _vm._v(" "), (_vm.availableSsoLogin.length > 0) ? _c('div', {
    staticClass: "adduser-input login-options"
  }, [_c('label', [_vm._v("Auth type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.disableSso),
      expression: "form.disableSso"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.disableSso = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v(_vm._s(_vm.availableSsoLogin))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Internal Auth")])])]) : _vm._e()], 2)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row d-flex justify-content-center mt-5"
  }, [_c('div', {
    staticClass: "col d-flex justify-content-center"
  }, [_c('ClientColorButton', {
    attrs: {
      "inactiveColor": true,
      "class-name": "mr-3"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.backToUsersList($event)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t(!_vm.obj.valid || (!_vm.newUser && _vm.isHasAccessBrand) ? "createUser.backToUsersList" : "common.cancel")) + "\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col d-flex justify-content-center"
  }, [(_vm.obj.valid) ? _c('ClientColorButton', {
    attrs: {
      "inactiveColor": !_vm.obj.submitted,
      "disabled": !_vm.obj.submitted,
      "background-color": _vm.currentBrand.linksColor
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.createUser($event)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t(_vm.newUser ? "common.save" : _vm.isHasAccessBrand ? "createUser.manageUserRights" : "createUser.yesIConfirm")) + "\n                ")]) : _vm._e()], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14726f2c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/actions/CreateUser.vue
// module id = 3029
// module chunks = 0